module.exports = __webpack_public_path__ + "static/media/03.4ae5f984.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Infographics/slides/03.jpg
// module id = 978
// module chunks = 0